var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close",
    clipPath: "url(#clip0_131_1414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8346 5.34163L14.6596 4.16663L10.0013 8.82496L5.34297 4.16663L4.16797 5.34163L8.8263 9.99996L4.16797 14.6583L5.34297 15.8333L10.0013 11.175L14.6596 15.8333L15.8346 14.6583L11.1763 9.99996L15.8346 5.34163Z",
    fill: "url(#paint0_linear_131_1414)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_131_1414",
    x1: 4.16797,
    y1: 4.16663,
    x2: 17.9865,
    y2: 7.92819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48E02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_1414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseYellow);
export default __webpack_public_path__ + "static/media/close-yellow.4a670ef6bb6b25d6a68505583dca8d83.svg";
export { ForwardRef as ReactComponent };